import "./PaginationControl.css";
import { useSelector } from "react-redux";
import { selectTranslations } from "../../../services/i18n/i18nSlice";
import { useState, useRef } from "react";
import { Button } from "../../../components/Button";
import { selectUserInfo } from "../../../features/User/userSlice";

import Draggable from 'react-draggable';
import Calculator from "../../../components/Calculator/Calculator";

export default function PaginationControl(props) {

    const t = useSelector(selectTranslations)
    const user_info = useSelector(selectUserInfo)
    const proceedButton = useRef(null)
    const backButton = useRef(null)

    const [showCalculator, setShowCalculator] = useState(false)

    const changeQuestion = (index) => {
        props.handleChangeQuestion(index);
        proceedButton?.current?.blur();
        backButton?.current?.blur();
    }

    const questionIndex = () => props.questions.findIndex(q => q.question_id === props.navigationData?.currentQuestion)

    return ( 
        <div className="exam_pagination_control">
            <div className={`row align-items-center ${user_info?.user_data?.compensational_measures?.calculator_enabled ? "justify-content-between" : "justify-content-end"}`}>
                {
                    user_info?.user_data?.compensational_measures?.calculator_enabled &&
                    <div className="col-3 col-md-3 mb-3 d-flex align-items-center justify-content-center">
                        <Button onClick={()=>{setShowCalculator(!showCalculator)}}>{showCalculator ? t.exam.close_calculator : t.exam.open_calculator}</Button>
                        {
                            user_info?.user_data?.compensational_measures?.calculator_enabled && showCalculator ?
                                <div className="calculator_container">
                                    <Draggable>
                                        <div>
                                            <Calculator handleCloseCalculator={()=>{setShowCalculator(false)}}/>
                                        </div>
                                    </Draggable>
                                </div>
                            : ""
                        }
                    </div>
                }
                <div className="col-12 col-md-9 mb-3 d-flex align-items-center justify-content-between">
                    <Button className="white" 
                                disabled={questionIndex() === 0} 
                                style={questionIndex() === 0 ? {opacity:'0.1'} : {}
                                } 
                                onClick={() => { changeQuestion( props.questions[parseInt(questionIndex() - 1)]?.question_id)}}>
                        {t.question.previous}
                    </Button>
                    <Button className="white" 
                        disabled={props.questions && 
                                    ( parseInt(questionIndex()) + 1 === props.questions.length )
                                } 
                        style={props.questions && 
                                ( parseInt(questionIndex()) + 1 === props.questions.length ) ? {opacity:'0.1'} : {}
                            } 
                        onClick={() => { changeQuestion( props.questions[parseInt(questionIndex() + 1)]?.question_id)}} 
                    >
                        {t.question.following}
                    </Button>
                </div>
            </div>
        </div>
    )
}